/*
 * The legacy alarm wizard (alarms_steps.html): dropdown filtering for the
 * `.menuInput` / `.menuList` pairs, and loading an indicator's outputs and
 * parameters into the form once one is picked.
 *
 * Plain DOM, no Alpine. entries/app.js calls initIndicatorAutocomplete() on
 * every page and it returns at once unless the wizard's markup is present,
 * so the page needs no bundle of its own.
 */
import { api } from '../lib/api.js';

function fetchIndicatorParams(input, targetSelect) {
  const selectedIndicator = input.value.toLowerCase();
  if (!selectedIndicator) return;
  api.get(api.path('/alarms/getindicatoroutputs', selectedIndicator))
    .then((outputs) => {
      targetSelect.textContent = '';
      outputs.forEach((name) => targetSelect.appendChild(new Option(name, name)));

      return api.get(api.path('/alarms/getindicatorparams', selectedIndicator))
        .then((params) => {
          const paramElement = document.getElementById('indicatorparams');
          if (!paramElement) return;
          paramElement.textContent = Object.keys(params).map((k) => k + '=' + params[k] + ',').join('');
        });
    })
    .catch((e) => console.error('could not load indicator details', e));
}

export function initIndicatorAutocomplete() {
  const indicatorInput = document.getElementById('indicatorInput');
  if (!indicatorInput) return;

  const targetSelect = document.getElementById('parameter');
  indicatorInput.addEventListener('blur', () => fetchIndicatorParams(indicatorInput, targetSelect));

  const indicatorInput2 = document.getElementById('indicatorInput2');
  const targetSelect2 = document.getElementById('targetparameter');
  if (indicatorInput2 && targetSelect2) {
    indicatorInput2.addEventListener('blur', () => fetchIndicatorParams(indicatorInput2, targetSelect2));
  }

  const atags = document.querySelectorAll('.menuList a h3');

  // Picking an entry: copy it into the input above the menu and hide the menu.
  // mousedown rather than click, because the input's blur (which hides the
  // menu) fires before a click would.
  function pick(event, item) {
    const menuParent = item.closest('.menu');
    menuParent.style.display = 'none';
    const menuInput = menuParent.previousElementSibling.firstElementChild;
    menuInput.value = item.textContent;
    event.stopPropagation();
  }
  atags.forEach((item) => item.addEventListener('mousedown', (event) => pick(event, item)));

  function menuFor(input) { return input.parentElement.nextElementSibling; }

  function onkeyup(input) {
    const ifilter = input.value.toUpperCase();
    atags.forEach((atag) => {
      atag.style.display = atag.textContent.toUpperCase().indexOf(ifilter) > -1 ? '' : 'none';
    });
  }

  const inputs = document.getElementsByClassName('menuInput');
  for (const input of inputs) {
    input.addEventListener('focus', () => { menuFor(input).style.display = 'block'; });
    input.addEventListener('blur', () => { menuFor(input).style.display = 'none'; });
    input.addEventListener('keyup', () => onkeyup(input));
  }
}
